module.exports = __webpack_public_path__ + "static/media/plane.5fdb61c2.jpg";